import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Form, Submit} from "react-forms";
import {FormattedMessage} from "react-intl";
import {toast} from 'react-toastify';

import Modal from "../../../components/Modal";

import {previewNewsletter} from "../../../data/entities/Newsletter";
import ContentLoader from "../../../components/ContentLoader";

class NewsletterPreviewModal extends Component
{
    state = {
        loading: false
    }

    componentDidMount() {
        this._load()
    }

    _load = () => {
        this.setState({ loading: true })

        this.props.previewNewsletter(this.props.data.id)
            .then((res) => {
                this.setState({ loading: false })
                const iframe = this.refs.iframe;
                const document = iframe.contentDocument;
                document.body.innerHTML = res.payload.data.html;
            })
            .catch((e) => {
                if (e.error && e.error.response && e.error.response.data) {
                    if (e.error.response.data.error) toast.error(<FormattedMessage id={e.error.response.data.error} />)
                    else if (e.error.response.data.message) toast.error(<FormattedMessage id={e.error.response.data.message} />)
                }
                this.setState({ loading: false })
            })
    }

    render()
    {
        return (
            <Modal title="Prévisualisation" onClose={() => this.props.onClose(false)}>
                {this.state.loading ? <ContentLoader/> : null}
                <iframe
                    style={{ height: '80vh' }}
                    ref="iframe"
                    className={"w-100" + (this.state.loading ? ' d-none' : '')}
                />
            </Modal>
        )
    }
}

export default connect(null, { previewNewsletter })(NewsletterPreviewModal)